import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18dbaf9b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center flex items-center justify-center min-h-screen" }
const _hoisted_2 = { class: "signup-form" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-4 mt-5" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "xr-icon-xarcade h1",
    style: {"font-size":"60px"}
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-4 text-white text-xl" }, "Forgot Password", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2 mb-4 text-gray-text text-lg" }, [
  /*#__PURE__*/_createTextVNode("Enter your user account's verified"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("email address and we will send you a"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("password reset link.")
], -1))
const _hoisted_7 = { class: "form-group mb-2" }
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "xr-icon-mail text-blue-primary opacity-75" })
  ])
], -1))
const _hoisted_10 = {
  key: 0,
  class: "alert alert-danger my-3",
  role: "alert"
}
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = {
  key: 1,
  class: "btn-primary-full"
}
const _hoisted_13 = {
  key: 1,
  class: "reset-success"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-4 mt-5" }, null, -1))
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-white mt-4 text-xl" }, "Email has been sent", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "px-5 text-gray-text text-md" }, "Please check your inbox and click in the received link to reset a password.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_authFooter = _resolveComponent("authFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.activeSection == 'forgotPassword')
        ? (_openBlock(), _createElementBlock("form", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  name: "Email",
                  placeholder: "Email",
                  required: "",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.email]
                ])
              ])
            ]),
            (_ctx.errorSection === true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              (_ctx.activeSection != 'loadingForgotPassword')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.forgotPassword && _ctx.forgotPassword(...args))),
                    class: "btn-primary-full"
                  }, "Submit"))
                : _createCommentVNode("", true),
              (_ctx.activeSection == 'loadingForgotPassword')
                ? (_openBlock(), _createElementBlock("button", _hoisted_12, "Submitting..."))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeSection == 'forgotPasswordSuccess')
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("img", {
              class: "mt-4 inline-block",
              src: _ctx.image
            }, null, 8, _hoisted_15),
            _hoisted_16,
            _hoisted_17
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_authFooter)
    ])
  ]))
}